import { memo } from "react"

const SuccessIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Check" clip-path="url(#clip0_4679_4249)">
        <path
          id="Check_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8086 24C19.436 24 24.8086 18.6274 24.8086 12C24.8086 5.37258 19.436 0 12.8086 0C6.18117 0 0.808594 5.37258 0.808594 12C0.808594 18.6274 6.18117 24 12.8086 24ZM17.4755 7.75741C17.9441 7.28881 18.704 7.28879 19.1726 7.75741C19.6412 8.22604 19.6412 8.98588 19.1726 9.45444L12.3843 16.2427C11.9157 16.7113 11.1558 16.7113 10.6872 16.2427L6.44462 12C5.976 11.5314 5.97602 10.7716 6.44462 10.303C6.91322 9.83436 7.67305 9.83436 8.14167 10.303L11.5358 13.6972L17.4755 7.75741Z"
          fill="#1EA672"
        />
      </g>
      <defs>
        <clipPath id="clip0_4679_4249">
          <rect width="24" height="24" fill="white" transform="translate(0.808594)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(SuccessIcon)
